import { render, staticRenderFns } from "./TsCo.vue?vue&type=template&id=459a0dc9&scoped=true"
import script from "./TsCo.vue?vue&type=script&lang=js"
export * from "./TsCo.vue?vue&type=script&lang=js"
import style0 from "./TsCo.vue?vue&type=style&index=0&id=459a0dc9&prod&lang=scss"
import style1 from "./TsCo.vue?vue&type=style&index=1&id=459a0dc9&prod&lang=scss&scoped=true"
import style2 from "./TsCo.vue?vue&type=style&index=2&id=459a0dc9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459a0dc9",
  null
  
)

export default component.exports